export default __webpack_public_path__ + "f1077b457e73844f2b8009e98640aaa3.png";